import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router'

import { CardTab, DataCardWithTabs } from '@/components/card'
import { DownloadCsv } from '@/components/DownloadCsv'
import { usePlayers } from '@/stores/players'

import { PlayersTableView } from './PlayersTableView'
import { QuarantinePlayersTableView } from './QuarantineTableView'
import { StandarizedGolfPlayer } from './types'

const TABS = [
  {
    value: 'players',
    label: 'Players'
  },
  {
    value: 'quarantine',
    label: 'Quarantine'
  }
]

const playersCsvHeaders = [
  'Id:',
  'Name',
  'First Name',
  'Last Name',
  'Country',
  'ET Id',
  'PGA Id',
  'LPGATour Id',
  'LIV ID',
  'DoB',
  'Gender'
]

const formatPlayersCsvRow = (row: StandarizedGolfPlayer) => [
  `${row.id}`,
  `${row.displayName}`,
  `${row.firstName}`,
  `${row.lastName}`,
  `${row.country}`,
  `${row.etId}`,
  `${row.pgaId}`,
  `${row.lpgaId}`,
  `${row.livId}`,
  `${row.dateOfBirth}`,
  `${row.gender}`
]

export const PlayerDataView = () => {
  const navigate = useNavigate()
  const { '*': tabParam } = useParams()
  const allPlayersData = usePlayers((s) => s.data)

  const DEFAULT_TAB = TABS[0].value
  const tab = TABS.some((t) => t.value === tabParam) ? tabParam : undefined

  useEffect(() => {
    if (!tab) {
      navigate(`/data-admin/player-data/${DEFAULT_TAB}`, { replace: true })
    }
  }, [tab, navigate])

  return (
    <>
      <DataCardWithTabs
        title="Golf Players Data"
        tabs={TABS}
        currentTab={tab || DEFAULT_TAB}
        onTabChange={(tab) => {
          navigate(`/data-admin/player-data/${tab}`, { replace: true })
        }}
        headerPostfixActions={
          (tab || DEFAULT_TAB) === 'players' && (
            <DownloadCsv
              data={allPlayersData}
              csvFileName="Players CSV"
              csvHeaders={playersCsvHeaders}
              formatCsvRow={formatPlayersCsvRow}
            />
          )
        }
      >
        <CardTab value="players">
          <PlayersTableView />
        </CardTab>
        <CardTab value="quarantine">
          <QuarantinePlayersTableView />
        </CardTab>
      </DataCardWithTabs>
    </>
  )
}
